/*
 * Copyright (c) 2021. Manchester Economic Forecasting Limited <http://mef-uk.com>
 */

import * as React from 'react';
import { Container, createStyles, makeStyles } from '@material-ui/core';

type Props = {
	children: NonNullable<React.ReactNode>;
};

const useStyles = makeStyles((theme) =>
	createStyles({
		container: {
			marginTop: theme.spacing(2),
		},
	})
);

const Layout = ({ children }: Props): JSX.Element => {
	const styles = useStyles();
	return <Container className={styles.container}>{children}</Container>;
};

export default Layout;
